// extracted by mini-css-extract-plugin
export default {"snackbar":"SnackBar_snackbar__Y515S","show":"SnackBar_show__k9mnT","hide":"SnackBar_hide__Mj7M6","closeIcon":"SnackBar_closeIcon__4LJEL"};